import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
export function useComputerModeDecorativeGlow(selectedSearchMode) {
    return selectedSearchMode === SearchMode.ASI;
}
//# sourceMappingURL=useComputerModeDecorativeGlow.js.map